module.exports = __webpack_public_path__ + "static/carbon-datepicker-light-ca283cadf3a669f9e93cbebecc3564be.png";